import { Component, OnInit } from '@angular/core';
import { ProgrammeServiceService } from './programme-service.service';
import { ProgrammeCard } from './programme-model';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BusinessService } from '../../services/business/business-category.service';

@Component({
  selector: 'app-programme-stats',
  templateUrl: './programme-stats.component.html',
  styleUrls: ['./programme-stats.component.css']
})
export class ProgrammeStatsComponent implements OnInit {
  programmeCards: ProgrammeCard[] = [];
  activeProgrammeId: number = 0;
  programmeUsers: any[] = [];
  filteredProgrammeUsers: any[] = [];
  searchText = '';

  selectedDirectoryId?: number;
  documentHours: any[] = [];
  programmeTotalHours: number = 0;
  totalCompleted = 0;
  userContentWatch: any[] = [];

  selectedClientId?: number;
  startDate?: string;
  endDate?: string;
  clients: any[] = [];
  topContentReport: any[] = [];
  selectedProgrammeId: number | null = null;
  hasGeneratedTopContentReport = false;

  topUserEngagement: any[] = [];
  hasGeneratedEngagement = false;
  engagementSummary = {
    totalWorkshopHours: 0,
    totalLearningCourseHours: 0,
    grandTotalHours: 0
  };

  isLoadingEngagement = false;
  pastMembers: any[] = [];
  showPastMembers = false;
  pastMemberCount = 0;
  differentClients = 0;
  loading = false;
  constructor(public statsService: ProgrammeServiceService, public businessService: BusinessService) { }

  ngOnInit() {
    this.loadProgrammeCards();
    this.loadClients()
   
  }

  loadProgrammeCards() {
    this.statsService.getProgrammeCards().subscribe(res => {
      this.programmeCards = res;
    });
  }

  selectProgramme(id: number) {
    this.selectedProgrammeId = id;
     this.loadPastMembers();
    this.resetProgrammeData();

    this.statsService.getProgrammeUsers(id).subscribe(data => {
      this.programmeUsers = data;
      this.filteredProgrammeUsers = [...this.programmeUsers];
    });

  }
  filterProgrammeUsers() {

    const term = (this.searchText || '').toLowerCase().trim();

    if (!term) {
        this.filteredProgrammeUsers = [...this.programmeUsers];
        return;
    }

    this.filteredProgrammeUsers = this.programmeUsers.filter(user =>

        (user.FullName || '').toLowerCase().includes(term) ||
        (user.Email || '').toLowerCase().includes(term) ||
        (user.PhoneNumber || '').toLowerCase().includes(term) ||
        (user.ClientName || '').toLowerCase().includes(term) ||
        (user.CoachName || '').toLowerCase().includes(term)

    );
}

  loadPastMembers(): void {
    if (!this.selectedProgrammeId) {
      return;
    }
    console.log("loading past members for programme ID:", this.selectedProgrammeId);
    this.loading = true;
    this.businessService.getPastProgrammeMembers(this.selectedProgrammeId)
      .then((data: any[]) => {
        this.pastMembers = data || [];
        this.pastMemberCount = this.pastMembers.length;

        console.log('Past Members:', this.pastMembers);
        const uniqueClients: Record<string, boolean> = {};

        this.pastMembers.forEach(member => {
          if (member.ClientName) {
            uniqueClients[member.ClientName] = true;
          }
        });

        this.differentClients = Object.keys(uniqueClients).length;

        this.differentClients = Object.keys(uniqueClients).length;

        this.loading = false;

      })
      .catch(error => {

        console.error(error);

        this.loading = false;

      });

  }
  onDirectoryChange() {
    if (!this.selectedDirectoryId) {
      this.documentHours = [];
      this.programmeTotalHours = 0;
      this.totalCompleted = 0;
      return;
    }

    const directoryId = this.selectedDirectoryId;
    this.statsService.getDocumentHours(directoryId).subscribe((res: any[]) => {
      this.documentHours = res;
      this.programmeTotalHours = 0;
      this.documentHours.forEach(item => {
        this.programmeTotalHours += item.TotalHoursViewed;
      });

      this.statsService.getTotalCompleted(directoryId).subscribe(res => {
        this.totalCompleted = res;
      });

      this.statsService.getUserContentWatchReport(this.selectedDirectoryId!).subscribe(res => {
        this.userContentWatch = res;
      });

    });

  }

  downloadExcel(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.documentHours);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Document Hours');
    XLSX.writeFile(workbook, 'Document_Hours_Report.xlsx');
  }

  downloadContentWatch() {
    if (!this.userContentWatch || this.userContentWatch.length === 0) {
      alert('No data available to export.');
      return;
    }

    const worksheet = XLSX.utils.json_to_sheet(this.userContentWatch);
    const workbook = {
      Sheets: { 'User Content Watch': worksheet },
      SheetNames: ['User Content Watch']
    };

    const excelBuffer = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array'
    });

    const data = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });

    saveAs(data, 'user-content-watch-report.xlsx');
  }

  generateTopContentReport() {
    const filter = {
      parentId: this.selectedDirectoryId,
      clientId: this.selectedClientId,
      startDate: this.startDate,
      endDate: this.endDate
    };

    this.statsService.getTopContentWatchReport(filter).subscribe(
      (data) => {
        this.topContentReport = data;
        this.hasGeneratedTopContentReport = true;
      },
      (error) => {
        console.error(error);
        this.topContentReport = [];
        this.hasGeneratedTopContentReport = true;
      }
    );
  }

  loadClients() {
    this.statsService.getClients().subscribe({
      next: (res) => {
        this.clients = res;
      },
      error: (err) => {
        console.error('Error loading clients', err);
      }
    });
  }

  downloadTopContentReport(): void {
    if (!this.topContentReport.length) {
      return;
    }

    const exportData = this.topContentReport.map((item, index) => ({
      Rank: index + 1,
      Content: item.ContentName,
      TotalHoursWatched: Number(item.TotalHoursWatched.toFixed(2))
    }));

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
    const workbook: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Top Content');
    XLSX.writeFile(workbook, 'Top_Content_Report.xlsx');
  }
  resetProgrammeData() {
    this.programmeUsers = [];
    this.selectedDirectoryId = undefined;
    this.documentHours = [];
    this.programmeTotalHours = 0;
    this.totalCompleted = 0;
    this.userContentWatch = [];
    this.selectedClientId = undefined;
    this.startDate = undefined;
    this.endDate = undefined;
    this.topContentReport = [];
    this.hasGeneratedTopContentReport = false;
  }


  generateUserEngagementReport() {
    const filter = {
      parentId: this.selectedDirectoryId,
      clientId: this.selectedClientId,
      startDate: this.startDate,
      endDate: this.endDate
    };

    this.hasGeneratedEngagement = false;
    this.isLoadingEngagement = true;
    this.statsService.getEngagementSummary(filter).subscribe({
      next: (summary) => {
        this.engagementSummary = summary;
      },
      error: (err) => {
        console.error(err);
      }
    });

    this.statsService.getTopUserEngagement(filter).subscribe({
      next: (users) => {
        this.topUserEngagement = users;
        this.hasGeneratedEngagement = true;
        this.isLoadingEngagement = false;
      },
      error: (err) => {
        console.error(err);
        this.topUserEngagement = [];
        this.hasGeneratedEngagement = true;
        this.isLoadingEngagement = false;
      }
    });
  }

  downloadUserEngagementReport(): void {
    if (!this.topUserEngagement.length) {
      return;
    }

    const exportData = this.topUserEngagement.map((user, index) => ({
      Rank: index + 1,
      Name: user.FullName,
      Email: user.Email,
      TotalHours: Number(user.TotalCombinedHours.toFixed(2))
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      'Top User Engagement'
    );

    XLSX.writeFile(
      workbook,
      'Top_User_Engagement.xlsx'
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/components/programme-stats/programme-stats.component.ts